import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  errorRoot: {
    borderBottom: "0.12rem solid red",
  },
  error: {
    backgroundColor: "var(--red-accent-3)",
  },
});
